import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BarChart3, Send, Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { errMsg } from "@/lib/api";

const inp = "h-10 px-3 rounded-lg border text-sm outline-none focus:ring-2 focus:ring-[#B91C1C]";

export function DailySummaryCard({ req }) {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState("");
  const load = useCallback(() => req("get", "/staff/daily-summary").then(setCfg).catch((e) => toast.error(errMsg(e))), [req]);
  useEffect(() => { load(); }, [load]);
  if (!cfg) return null;

  const save = async (patch, msg) => {
    const next = { enabled: cfg.enabled, time: cfg.time, ...patch };
    setBusy("save");
    try { setCfg({ ...cfg, ...(await req("put", "/staff/daily-summary", next)) }); toast.success(msg || (next.enabled ? "Ringkasan harian DIHIDUPKAN" : "Ringkasan harian DIMATIKAN")); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const sendNow = async () => {
    setBusy("send");
    try { await req("post", "/staff/daily-summary/send"); toast.success("Ringkasan dihantar ke WhatsApp"); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const last = cfg.last_result;

  return (
    <section className="bg-white rounded-2xl border p-6 space-y-4" data-testid="daily-summary-card">
      <h3 className="font-display font-bold flex items-center gap-2"><BarChart3 className="w-5 h-5 text-red-700" />Ringkasan Harian WhatsApp</h3>
      <label className="flex items-center justify-between gap-4">
        <span className="text-sm">Hantar ringkasan jualan App + POS setiap malam<span className="block text-xs text-slate-500">Dihantar ke nombor admin dan group WhatsApp dalam tetapan di atas.</span></span>
        <Switch checked={!!cfg.enabled} disabled={!!busy} onCheckedChange={(v) => save({ enabled: v })} data-testid="daily-summary-enabled" />
      </label>
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm">Masa hantar</span>
        <input type="time" value={cfg.time} onChange={(e) => setCfg({ ...cfg, time: e.target.value })} data-testid="daily-summary-time" className={inp} />
        <button onClick={() => save({}, `Masa hantar disimpan: ${cfg.time}`)} disabled={!!busy} data-testid="daily-summary-save" className="px-4 h-10 rounded-lg bg-[#B91C1C] text-white text-sm font-semibold disabled:opacity-60">Simpan Masa</button>
        <button onClick={sendNow} disabled={!!busy} data-testid="daily-summary-send-now" className="px-4 h-10 rounded-lg border border-[#B91C1C] text-[#B91C1C] text-sm font-semibold flex items-center gap-2 disabled:opacity-60">
          {busy === "send" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}Hantar Sekarang
        </button>
      </div>
      <p className="text-xs text-slate-500" data-testid="daily-summary-status">
        {last && !last.ok ? `Percubaan terakhir gagal: ${last.error}` : cfg.last_sent ? `Terakhir dihantar: ${cfg.last_sent}` : "Belum pernah dihantar"}
        {" · Versi Vercel: dihantar sekali antara 11:00–11:59 malam."}
      </p>
      <details className="text-sm">
        <summary className="cursor-pointer text-[#B91C1C] font-medium" data-testid="daily-summary-preview-toggle">Lihat contoh mesej hari ini</summary>
        <pre className="mt-2 whitespace-pre-wrap rounded-lg bg-slate-50 border p-3 text-xs" data-testid="daily-summary-preview">{cfg.preview}</pre>
      </details>
    </section>
  );
}
